"use no memo";

import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

import { LoadingSpinner } from '@local/loading-indicators';
import {
  getUrlQualifiesForRedirectToMarketplace,
  redirectToMarketplaceHomepage,
} from 'helpers/configureRedirects';
import { ANALYTICS_EVENT_NAME, logAnalyticsEvent } from 'helpers/loggers';
import Footer from 'components/Footer';
import { ReactComponent as ImageNotFound } from 'images/notfound.svg';

import styles from './styles.module.scss';

type NotFoundPageProps = {
  type?: '404' | 'marketplace_disabled_page' | 'locations_not_found' | 'locations_empty' | 'restaurant_not_found' | 'restaurant_mismatch';
};

export const NotFoundPage: React.FunctionComponent<NotFoundPageProps> = ({
  type = '404',
}) => {
  const shouldRedirectToMarketplace = getUrlQualifiesForRedirectToMarketplace({
    url: window.location.href,
  });

  useEffect(() => {
    if (!shouldRedirectToMarketplace) {
      logAnalyticsEvent({
        eventName: ANALYTICS_EVENT_NAME.viewErrorPage,
        attributes: {
          type,
          url: window.location.href,
        },
      });
    }
  }, []);

  if (shouldRedirectToMarketplace) {
    redirectToMarketplaceHomepage();
    return <LoadingSpinner testId="loading-spinner" />;
  }

  return (
    <div className={styles.notFoundWrapper}>
      <Helmet>
        <title>Page Not Found</title>
      </Helmet>
      <main id="main-content" tabIndex={-1} className={styles.container}>
        <ImageNotFound className={styles.image} />
        <p className={styles.headline}>
          Oops! Something is not right.
          <br />
          We can&apos;t find the page you&apos;re looking for.
        </p>
        <a
          id="skip-link-target"
          tabIndex={-1}
          href="/"
          className={styles.button}
        >
          Go to Homepage
        </a>
      </main>
      <Footer />
    </div>
  );
};

export default NotFoundPage;
